import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export function getRedirectUrl(props, from = '/') {
  if (!props.user.config || !props.user.config.enableTenant) {
    return from.toLowerCase().includes('tenant/config') ? '/' : from;
  }
}

export default function(ComposedComponent) {
  class RequireEnableTenant extends Component {
    static contextTypes = {
      router: PropTypes.object
    };

    redirect(to) {
      global.window && window.location && window.location.replace(to + window.location.search);
    }

    render() {
      if (this.props.isLoading) {
        return <div></div>;
      }

      const redirectUrl = getRedirectUrl(this.props, this.props.router.location.pathname);
      if (redirectUrl) {
        this.redirect(redirectUrl);
        return null;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      isLoading: state.auth.isLoading,
      user: state.auth.user,
    };
  }

  return connect(mapStateToProps)(RequireEnableTenant);
}
